<div class="d-flex flex-column gap-3" data-testid="subscribers-panel">
  <div class="d-flex flex-column gap-1">
    <h3 class="av-section-title m-0">{{ 'backoffice.plans.subscribers.title' | translate }}</h3>
    <p class="av-meta m-0">{{ 'backoffice.plans.subscribers.hint' | translate }}</p>
  </div>

  @switch (facade.subscribersState()) {
    @case ('error') {
      <av-empty-state
        icon="error_outline"
        [title]="'backoffice.plans.subscribers.error.title' | translate"
        [message]="'backoffice.plans.subscribers.error.message' | translate"
      ></av-empty-state>
    }
    @case ('ready') {
      @if (isEmpty()) {
        <av-empty-state
          icon="corporate_fare"
          [title]="'backoffice.plans.subscribers.empty.title' | translate"
          [message]="'backoffice.plans.subscribers.empty.message' | translate"
        ></av-empty-state>
      } @else {
        <div class="table-scroll">
          <table class="av-table w-100" data-testid="subscriber-table">
            <thead>
              <tr>
                <th scope="col">
                  {{ 'backoffice.plans.subscribers.columns.organization' | translate }}
                </th>
                <th scope="col">
                  {{ 'backoffice.plans.subscribers.columns.status' | translate }}
                </th>
                <th scope="col">
                  {{ 'backoffice.plans.subscribers.columns.started' | translate }}
                </th>
                <th scope="col">
                  {{ 'backoffice.plans.subscribers.columns.trial_ends' | translate }}
                </th>
                <th scope="col" class="text-end">
                  {{ 'backoffice.plans.subscribers.columns.mrr' | translate }}
                </th>
                <th scope="col" class="text-end">
                  {{ 'backoffice.plans.subscribers.columns.actions' | translate }}
                </th>
              </tr>
            </thead>

            <tbody>
              @for (subscriber of facade.subscribers(); track subscriber.subscription_id) {
                <tr>
                  <td class="cell-strong">{{ subscriber.organizationLabel }}</td>

                  <td>
                    <div class="d-flex align-items-center gap-2">
                      <av-status-chip
                        [label]="subscriber.statusLabelKey | translate"
                        [tone]="subscriber.statusTone"
                      ></av-status-chip>

                      @if (subscriber.cancel_at_period_end) {
                        <av-status-chip
                          [label]="'backoffice.plans.subscribers.ending_at_term' | translate"
                          tone="warning"
                        ></av-status-chip>
                      }
                    </div>
                  </td>

                  <td class="cell-muted">
                    {{
                      subscriber.started_at
                        ? (subscriber.started_at | date: dateFormat)
                        : unresolved
                    }}
                  </td>

                  <td class="cell-muted">
                    {{
                      subscriber.trial_ends_at
                        ? (subscriber.trial_ends_at | date: dateFormat)
                        : unresolved
                    }}
                  </td>

                  <td class="text-end">{{ subscriber.mrr | number: '1.2-2' }}</td>

                  <td class="text-end">
                    <button type="button" class="av-btn" (click)="openOrganization(subscriber)">
                      <mat-icon aria-hidden="true">open_in_new</mat-icon>
                      {{ 'backoffice.common.actions.open' | translate }}
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <av-paginator
          [page]="facade.subscriberPage()"
          [pageSize]="facade.pageSize()"
          [total]="facade.subscriberTotal()"
          (pageChange)="goToPage($event)"
          (pageSizeChange)="changePageSize($event)"
        ></av-paginator>
      }
    }
    @default {
      <av-empty-state
        icon="hourglass_empty"
        [title]="'backoffice.plans.subscribers.loading.title' | translate"
        [message]="'backoffice.plans.subscribers.loading.message' | translate"
      ></av-empty-state>
    }
  }
</div>
